import React, { Component } from 'react';
import styled from 'styled-components';

import Html from 'partials/Html';

export class Tooltip extends Component {

    render() {
        if (this.props.idx === this.props.active) {
            return (
                <StyledTooltip content onClick={() => this.toggleVisibility()} className={this.props.className} bottom={this.props.bottom ? 1 : 0}>
                    {this.props.data}
                </StyledTooltip>
            )
        } else return null;
    }
}

export default Tooltip;

const StyledTooltip = styled(Html)`
    position: absolute;
    overflow: visible;
    bottom: ${props => props.bottom ? 'auto' : props.theme.spacing.contentXL};
    top: ${props => props.bottom ? props.theme.spacing.contentXL : 'auto'};
    left: 0;
    transform: translateX(-50%);
    min-width: 300px;
    background-color: ${props => props.theme.colors.tooltip};
    padding: ${props => props.theme.spacing.contentL};
    border-radius: ${props => props.theme.spacing.contentM};

    &::after {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 8px solid ${props => props.theme.colors.tooltip};
        content: ' ';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: rotate(180deg);
    }
`